import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {setActiveMultiselectDropdown} from '../../redux/actions';

class TagsMultiSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      choices: this.props.selectedValues,
      options: this.props.options,
    };
  }

  componentWillReceiveProps(nextProps) {
    // console.log('componentWillReceiveProps', nextProps.activeMultiselectDropdown);

    if (this.props.label !== nextProps.activeMultiselectDropdown) {
      this.setState({
        active: false,
      });
    }
  }

  onMultiSelectToggle() {
    // console.log('onMultiSelectToggle');
    this.props.setActiveMultiselectDropdown(this.props.label);

    this.setState({
      active: !this.state.active,
      options: this.props.options,
    });
  }

  onCheckBoxClick(event) {
    // console.log('onCheckBoxClick', event);

    if (event.target.checked) {
      this.setState({choices: [...this.state.choices, event.target.value]});

      // let displays = this.state.displays;
      // if (displays == undefined) {
      //   displays = [];
      // }

      // this.setState({ displays: [...displays, event.target.getAttribute('label')] });
      this.props.onChangeHandler([...this.state.choices, event.target.value]);
    } else {
      const filteredChoices = this.state.choices.filter((choice) => {
        return choice !== event.target.value;
      });
      this.setState({choices: filteredChoices});

      console.log('filteredChoices', filteredChoices);
      this.props.onChangeHandler(filteredChoices);

      // const filteredDisplays = this.state.displays.filter(display => {
      //   return display !== event.target.getAttribute('label');
      // });
      // this.setState({ displays: filteredDisplays });
    }
  }

  defaultChecked(value) {
    // console.log('defaultChecked value', value);
    let selectedValues = this.props.selectedValues;
    if (typeof selectedValues === 'string') {
      selectedValues = JSON.parse(selectedValues.replace(/['"]+/g, ''));
    }

    // console.log('before', selectedValues);
    if (selectedValues == null) {
      return;
    }
    return selectedValues.find(
      (choice) => choice.toString() === value.toString(),
    );
  }

  tagRemove(id) {
    console.log('tagRemove', id);

    const filteredChoices = this.state.choices.filter((choice) => {
      return choice !== id;
    });
    this.setState({choices: filteredChoices});

    console.log('filteredChoices', filteredChoices);
    this.props.onChangeHandler(filteredChoices);
  }

  render() {
    return (
      <div className="field-wrapper">
        <label className="field-label">{this.props.label}</label>
        <div className="field">
          <div
            className={`form-element multi-select tags-multi-select ${
              this.state.active && 'multi-select-active'
            }`}
            onClick={() => this.onMultiSelectToggle()}>
            {!this.state.active && (
              <div className="search-tags form-element">
                {this.state.choices.map((choice, index) => {
                  return this.state.options.map((option, index) => {
                    if (choice === option.value) {
                      return (
                        <div className="tag">
                          {option.label}
                          <span
                            className="remove"
                            onClick={() => this.tagRemove(choice)}></span>
                        </div>
                      );
                    }
                    return null;
                  });
                })}
              </div>
            )}
          </div>

          {this.state.active && (
            <div className="form-element multi-select-tray active">
              {this.state.options.map((option, key) => {
                return (
                  <div key={key} className="form-element hlp-flex flex-jcfs">
                    <input
                      className="xform-element"
                      type="checkbox"
                      value={option.value}
                      id={key}
                      label={option.label}
                      onChange={(e) => this.onCheckBoxClick(e)}
                      defaultChecked={this.defaultChecked(option.value)}
                    />
                    <label className="form-element" type="label" htmlFor={key}>
                      {option.label}
                    </label>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {activeMultiselectDropdown} = state.god;
  return {activeMultiselectDropdown};
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setActiveMultiselectDropdown,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TagsMultiSelect);
